<template>
    <section class="info-tiles">
        <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
                <article class="tile is-child box clock" id="clock">
                    <p class="date">{{ japan.date }}</p>
                    <p class="time">{{ japan.time }}</p>
                    <p class="text">Time in Japan</p>
                </article>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box clock" id="id-clock">
                    <p class="date">{{ local.date }}</p>
                    <p class="time">{{ local.time }}</p>
                    <p class="text">Your local time</p>
                </article>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <p class="title">{{ usd }}¥</p>
                    <p class="subtitle">USD to JPY</p>
                </article>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <p class="title">{{ nzd }}¥</p>
                    <p class="subtitle">NZD to JPY</p>
                </article>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <p class="title">{{ eur }}¥</p>
                    <p class="subtitle">EUR to JPY</p>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
    import apiRates from './../../api/apiRates'
    import moment from 'moment'
    export default {
        data () {
            return {
                usd: '',
                nzd: '',
                eur: '',
                el: '#clock',
                local: {
                    time: '',
                    date: ''
                },
                japan: {
                    time: '',
                    date: ''
                }
            }

        },
        methods: {
            zeroPadding(num, digit) {
                let zero = ''
                for(let i = 0; i < digit; i++) {
                    zero += '0'
                }
                return (zero + num).slice(-digit)
            },
            getLocalTime () {
                let week = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
                let self = this;
                setInterval(function(){
                    let cd = new Date()
                    self.local.time =  self.zeroPadding(cd.getHours(), 2) + ':' + self.zeroPadding(cd.getMinutes(), 2) + ':' + self.zeroPadding(cd.getSeconds(), 2)
                    self.local.date =  self.zeroPadding(cd.getFullYear(), 4) + '-' + self.zeroPadding(cd.getMonth()+1, 2) + '-' + self.zeroPadding(cd.getDate(), 2) + ' ' + week[cd.getDay()]
                }, 1000)
            },
            getJapanTime () {
                let week = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
                let self = this;
                setInterval(function(){
                    let cd = moment().tz('Asia/Tokyo')
                    self.japan.time =  self.zeroPadding(cd.format('HH'), 2) + ':' + self.zeroPadding(cd.format('mm'), 2) + ':' + self.zeroPadding(cd.format('ss'), 2)
                    self.japan.date =  cd.format('Y') + '-' + cd.format('MM') + '-' + cd.format('DD') + ' ' + week[cd.day()]
                }, 1000)
            }
        },
        computed: {

        },
        mounted () {
            this.getLocalTime()
            this.getJapanTime()
            apiRates
                .getAllRatesRequest()
                .then((response) => {
                    this.usd = response.data[0].price
                    this.nzd = response.data[1].price
                    this.eur = response.data[2].price
                })
                .catch((error) => {
                    console.log(error)
                })

        }
    }
</script>

<style scoped>
    .clock {
        color: black;
        text-align: center;
    }
    .time {
        font-size: 20px;
    }
    .date {
        font-size: 16px;
    }
    .text {
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Rates.vue